/**
 * Capacitor-native pull-to-refresh (DEV-441). Browser (any width) has no PTR.
 */
export function shouldEnableShellPullToRefresh(input: {
  isCapacitorNative: boolean;
  hasHandler: boolean;
  scrollY: boolean;
}): boolean {
  return input.hasHandler && input.scrollY && input.isCapacitorNative;
}

export type ShellPullToRefreshDetail = {
  complete: () => void;
};

/** Always complete Ionic's refresher, even if the refetch rejects. */
export async function runPullToRefresh(
  event: { detail: ShellPullToRefreshDetail },
  refresh: () => void | Promise<void>,
): Promise<void> {
  try {
    await refresh();
  } catch {
    // Page error UI / React Query own the failure; the spinner must still dismiss.
  } finally {
    event.detail.complete();
  }
}
